module.exports = {
      id: "search-usage",
      viewBox: "0 0 512 512",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#search",
      toString: function () {
        return this.url;
      }
    }